// extracted by mini-css-extract-plugin
export default {"date-header":"HospitalIncidentsToolbar_date-header_SwnOI","search-toolbar":"HospitalIncidentsToolbar_search-toolbar_cNvKR"};